import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';

interface Props {
  color: string;
  title: string;
  quantity: number;
}
export const ItemSelectSupport: FC<Props> = ({ color, title, quantity }) => {
  return (
    <Box width="100%" display="flex" alignItems="center" mb={2}>
      <Box width={12} height={12} borderRadius={6} border={`6px solid ${color}`} />
      <Typography ml={1} color="white" textTransform="uppercase">
        {`${title}  -  ${quantity}`}
      </Typography>
      <Typography ml={1} color="white">
        шт.
      </Typography>
    </Box>
  );
};
